
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortName]/smart-farming",
      function () {
        return require("private-next-pages/[shortName]/smart-farming/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortName]/smart-farming"])
      });
    }
  